import { JmApi } from "../jm-api/jm-api";
import { DataInstance } from "./data-instance";

export class Adress extends DataInstance {
  public static readonly BASE_URL =
    import.meta.env.VITE_CLEVERREACH_API_BASE_URL + "/jmapi/v1/adresses";

  private data: {
    id: number;
    street: string;
    house_number: string;
    postal_code: string;
    district: string;
    geo: {
      coordinates: [number, number];
      type: string;
    };
  };

  constructor(
    id: number,
    street: string,
    house_number: string,
    postal_code: string,
    district: string,
    geo: { coordinates: [number, number]; type: string } = {
      coordinates: [1, 1],
      type: "Point",
    },
  ) {
    super();
    this.data = {
      id: id,
      street: street,
      house_number: house_number,
      postal_code: postal_code,
      district: district,
      geo: geo,
    };
  }

  static postUrlBuilder() {
    return Adress.BASE_URL;
  }

  static getUrlBuilder(projectId: number, companyId: number, officeId: number) {
    return `${Adress.BASE_URL}?projId=${projectId}&CompanyId=${companyId}&officeId=${officeId}`;
  }

  static putUrlBuilder(adressId: number): string {
    return `${Adress.BASE_URL}?AdressId=${adressId}`;
  }

  static deleteUrlBuilder(adressId: number): string {
    return `${Adress.BASE_URL}?AdressId=${adressId}`;
  }

  get currentData(): object {
    return this.data;
  }

  get currentId(): number | undefined {
    return this.id;
  }

  set currentId(id: number | undefined) {
    this.id = id;
  }

  async post(chain: boolean = false): Promise<string> {
    return new Promise((resolve, reject) => {
      JmApi.post(Adress.postUrlBuilder(), this.data)
        .then((response) => {
          if (chain) {
            resolve("Adresse erfolgreich hinzugefügt");
          }
        })
        .catch((response) => {
          if (chain) {
            reject("post unsuccessful");
          }
        });
    });
  }

  static fromObject(o: object): Adress | null {
    if (o["street"] && o["house_number"] && o["postal_code"] && o["district"]) {
      return new Adress(
        o["id"],
        o["street"],
        o["house_number"],
        o["postal_code"],
        o["district"],
      );
    } else {
      return null;
    }
  }
}
